import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './query-client';
import { router } from './router';

/**
 * Raiz de composição.
 *
 * Só monta os provedores e entrega o roteador. Nenhuma regra e nenhuma tela
 * aqui — as páginas entram pela árvore de rotas, carregadas sob demanda.
 */
export function App(): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
